import { createActions, createReducer, resettableReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: {},
  error: null,
};

const { Types, Creators } = createActions(
  {
    reset: [],
    getLatestRedemptions: ['params'],
    getLatestRedemptionsRequest: [],
    getLatestRedemptionsSuccess: ['data'],
    getLatestRedemptionsFailure: ['error'],
  },
  { prefix: 'cb/latestRedemptions/' },
);

export { Types as types, Creators as actions };

export const request = state => ({
  ...state,
  fetching: true,
});

export const success = (state, action) => ({
  fetching: false,
  fetched: true,
  data: action.data,
  error: INITIAL_STATE.error,
});

export const getFailure = (options = { reset: false }) => (state, action) => ({
  fetching: false,
  fetched: options.reset ? INITIAL_STATE.fetched : state.fetched,
  data: options.reset ? INITIAL_STATE.data : state.data,
  error: action.error,
});

export const HANDLERS = {
  [Types.GET_LATEST_REDEMPTIONS_REQUEST]: request,
  [Types.GET_LATEST_REDEMPTIONS_SUCCESS]: success,
  [Types.GET_LATEST_REDEMPTIONS_FAILURE]: getFailure(true),
};

export default resettableReducer(Types.RESET)(
  createReducer(INITIAL_STATE, HANDLERS),
);